function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7073 4.75532L10.2987 4.75515C10.019 4.75526 9.79237 4.98185 9.79224 5.26157C9.79224 5.54141 10.0191 5.76827 10.2988 5.76814L11.7074 5.76832C13.1956 5.76848 14.4144 6.98875 14.4245 8.48538C14.4245 9.97317 13.2045 11.1921 11.7076 11.2023L10.299 11.2024C10.0193 11.2022 9.79245 11.4291 9.79244 11.7089C9.79245 11.9888 10.0192 12.2155 10.2989 12.2154L11.711 12.2154C12.7372 12.2085 13.6682 11.7876 14.3427 11.1131C15.0186 10.4371 15.4373 9.50629 15.4375 8.48198C15.4235 6.42695 13.7503 4.75527 11.7073 4.75532Z",
  fill: "#0D5AE5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67167 4.75517L5.25941 4.755C3.20473 4.76879 1.53308 6.4421 1.5329 8.48844C1.54682 10.5434 3.22009 12.215 5.26308 12.215L6.67189 12.2151C6.8117 12.2152 6.93836 12.1585 7.03005 12.0668C7.12161 11.9752 7.17833 11.8486 7.17821 11.7085C7.17832 11.4288 6.95148 11.202 6.67174 11.202L5.26294 11.202C3.77487 11.202 2.55598 9.98166 2.54591 8.48499C2.54611 6.99692 3.76636 5.77812 5.2629 5.768L6.67171 5.76804C6.95158 5.76804 7.17816 5.54146 7.17815 5.26159C7.17824 4.9819 6.9514 4.75505 6.67167 4.75517Z",
  fill: "#0D5AE5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2272 7.91778L6.61646 7.91779C6.33817 7.91766 6.1125 8.14333 6.11261 8.42164C6.1125 8.69992 6.33817 8.92559 6.61646 8.92549L10.2272 8.92548C10.3664 8.92548 10.4923 8.86918 10.5835 8.77795C10.6747 8.68673 10.731 8.56084 10.731 8.42163C10.7311 8.14334 10.5055 7.91767 10.2272 7.91778Z",
  fill: "#0D5AE5"
});

var SvgCopyLinkIcon = function SvgCopyLinkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyLinkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Copy_link_icon.f2b57606.svg";
export { ForwardRef as ReactComponent };